import CustomButton from '../../components/Button'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import OnlinePredictionIcon from '@mui/icons-material/OnlinePrediction'
import StarsIcon from '@mui/icons-material/Stars'
import SchoolIcon from '@mui/icons-material/School'
import { isAdmin } from '../../helpers/utils'
import { Navigate, useNavigate } from 'react-router-dom'
import { AppRoutes } from '../../helpers/routes'
import StatisticsHeader from './StatisticsHeader'
import { useEffect, useState } from 'react'
import { AppConfig } from '../../models/shared'
import UtilitiesService from '../../services/UtilitiesService'
import CustomPaper from '../../containers/Paper'
import { CircularProgress } from '@mui/material'

export const statisticsColors = {
    background: [
        'rgba(255, 99, 132, 0.6)',
        'rgba(255, 159, 64, 0.6)',
        'rgba(75, 192, 192, 0.6)',
        'rgba(54, 162, 235, 0.6)',
        'rgba(255, 205, 86, 0.6)',
        'rgba(153, 102, 255, 0.6)',
        'rgba(201, 203, 207, 0.6)',
    ],
    border: [
        'rgb(255, 99, 132)',
        'rgb(255, 159, 64)',
        'rgb(75, 192, 192)',
        'rgb(54, 162, 235)',
        'rgb(255, 205, 86)',
        'rgb(153, 102, 255)',
        'rgb(201, 203, 207)',
    ],
}

const StatisticsPage = () => {
    const navigate = useNavigate()
    const [config, setConfig] = useState<AppConfig | null>()

    useEffect(() => {
        new UtilitiesService().getAppConfig().then((response) => {
            if (response.status !== 200) setConfig(null)
            else setConfig(response.data)
        })
    }, [])

    const CategoryButton = ({
        text,
        icon,
        path,
    }: {
        text: string
        icon: JSX.Element
        path: string
    }) => {
        return (
            <CustomButton
                className="rounded-[24px] h-[130px] md:h-full text-base md:text-4xl font-bold"
                disableElevation
                secondary
                onClick={() => navigate(path)}
            >
                <div className="flex flex-col gap-2 items-center">
                    {text}
                    {icon}
                </div>
            </CustomButton>
        )
    }

    return (
        <>
            {isAdmin() ? (
                config === undefined ? (
                    <div className="w-full h-[calc(100vh-200px)] flex justify-center items-center">
                        <CircularProgress
                            className="m-2 md:m-5 text-primary"
                            size={120}
                        />
                    </div>
                ) : config !== null && !!config?.university && config?.careers.length > 0 ? (
                    <div className="w-full md:h-[calc(100vh-256px)] ">
                        <StatisticsHeader />
                        <div className="grid grid-cols-2 gap-5 md:gap-10 h-full mt-5">
                            <CategoryButton
                                text="Tendencias"
                                path={AppRoutes.statistics.tendencies}
                                icon={<TrendingUpIcon className="text-[70px] md:text-[120px]" />}
                            />
                            <CategoryButton
                                text="Áreas de éxito"
                                path={AppRoutes.statistics.successAreas}
                                icon={<StarsIcon className="text-[70px] md:text-[120px]" />}
                            />
                            <CategoryButton
                                text="Áreas de mejora"
                                path={AppRoutes.statistics.improvementAreas}
                                icon={
                                    <OnlinePredictionIcon className="text-[70px] md:text-[120px]" />
                                }
                            />
                            <CategoryButton
                                text="Formación académica"
                                path={AppRoutes.statistics.academic}
                                icon={<SchoolIcon className="text-[70px] md:text-[120px]" />}
                            />
                        </div>
                    </div>
                ) : (
                    <div className="w-full md:h-[calc(100vh-200px)] flex justify-center items-center mt-32 md:mt-0">
                        <CustomPaper className="w-[70vw] md:w-[40vw] flex flex-col gap-2 text-primary">
                            <span className="font-bold text-lg md:text-2xl">
                                La sección de estadísticas se encuentra deshabilitada.
                            </span>
                            <span className="text-base md:text-xl">
                                Probablemente se deba a que todavía no se configuró la información
                                sobre la institución.
                            </span>
                            <span className="text-sm md:text-lg">
                                Para hacerlo, ingresá a la sección de "Administradores" y buscá el
                                botón correspondiente.
                            </span>
                        </CustomPaper>
                    </div>
                )
            ) : (
                <Navigate to={AppRoutes.home} />
            )}
        </>
    )
}

export default StatisticsPage
